import { BLLViewCariler } from './../../../providers/bll/bll-viewCariler';
import { CariHareketleriPage } from './../cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from './../carialacakdekont/carialacakdekont';
import { CariborcdekontPage } from './../cariborcdekont/cariborcdekont';
import { CariTahsilatPage } from './../../CariIslemleri/cari-tahsilat/cari-tahsilat';
import { CarieklePage } from './../cariekle/cariekle';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component,ViewChild } from '@angular/core';
import {  NavController, NavParams, ActionSheetController, Searchbar } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { CariOdemePage } from '../../cari-odeme/cari-odeme';
import { CariIslemPage } from '../cari-islem/cari-islem';




@Component({
  selector: 'page-cariler',
  templateUrl: 'cariler.html',
})
export class CarilerPage {
  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('searchbar') searchbar: Searchbar;
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi =[];
  numaralar: any = {};
  telno = "";
secilenCariGrupID:number=-1;
GrupListesi=[];

  constructor(public navCtrl: NavController,public bllOrtak:BllOrtak,
    public ortak:Ortak,
    
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

 

  ionViewDidLoad() {
   this.cariAra("");
   this.kayitAra();
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }

  
  kayitAra() {

    this.bllOrtak.islemWithoutPost("CariGrupListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.GrupListesi = sonuc.SonucObject;
   
   
 
    })
  }

  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {

    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
    this.searchbar.setFocus();

  }

  cariAra(e) {
   
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("grupKodu", this.secilenCariGrupID.toString());
    formData.append("skip", this.skip.toString());
    formData.append("take", this.ortak.StAyarGetir.CariListeSayisi.toString());
    console.log("grupKodu", this.secilenCariGrupID.toString());
    this.bllOrtak.islem(formData, "CariListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
      console.log("gelenL",this.cariListesi)
      this.closeNav();
  
 
    })
  }
  OfflineCariGetir()
  {
    var bllViewCariler=new BLLViewCariler();
    bllViewCariler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(Definition_,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + this.aranan + "%' or Kodu='" + this.aranan + "')" + " order by Definition_").then(a => {
        this.cariListesi = a;
      if (this.cariListesi.length == 0) {
        this.cariAra("");
       
      }
     
    });

  }
  urunler() {
    
      if(this.aranan.length>3)
      {
        this.cariAra("");
 
      }
      if(this.aranan.length==0)
      {
        this.cariAra("");
      }
    
    
  }
  yeni() {
    let modal = this.modalCtrl.create(CarieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  CariSil(cari) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("LogicalRef", cari.ID);

      this.bllOrtak.islem(formData, "CariSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.cariAra(null);
    })

}
CariGuncelle(kisi) {
  let modal = this.modalCtrl.create(CarieklePage, { vwCari: kisi },{ cssClass: "genisekran" });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariTahsilat(kisi) {
  let modal = this.modalCtrl.create(CariTahsilatPage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariDekont(kisi){
  let modal=this.modalCtrl.create(CariborcdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
carihareketleri(kisi){
  let modal=this.modalCtrl.create(CariHareketleriPage,{vwCari:kisi},{ cssClass: "genisekran" });
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();

}
CariAlacak(kisi){
  let modal=this.modalCtrl.create(CarialacakdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
CariOdeme(kisi){
  let modal = this.modalCtrl.create(CariOdemePage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariIslemleri(kisi){
  let modal=this.modalCtrl.create(CariIslemPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
   
  });
  modal.present();
  
}
Islemler(kisi) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Cari  İşlemleri',
    buttons: [
      {
        text: 'Cari Hareketleri',

        handler:()=>{
      this.carihareketleri(kisi);
        }
       
      },
      {
        text: 'Alacak Dekontu',

        handler:()=>{
        this.CariAlacak(kisi);
        }
       
      },
      {
        text: 'Borç Dekontu',

        handler:()=>{
        this.CariDekont(kisi);
        }
       
      },
      {
        text: 'Tahsilat Yap',

        handler:()=>{
        this.CariTahsilat(kisi);
        }
       
      },
      {
        text: 'Ödeme Yap',

        handler:()=>{
          this.CariOdeme(kisi);
        }
       
      },{
        text: 'Düzenle',
        handler: () => {
         this.CariGuncelle(kisi);
        }
      },{
        text: 'İptal ',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
}

  

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cariler/cariler.ts